import { render, staticRenderFns } from "./StockInventoryLotBreakdownDialog.vue?vue&type=template&id=38923a2c"
import script from "./StockInventoryLotBreakdownDialog.vue?vue&type=script&lang=js"
export * from "./StockInventoryLotBreakdownDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports